<div class="user-info">
	<p class="user">
		{{ userDisplayName() }}
	</p>
	@if (userMainFunction()) {
		<p class="main-function mt-1 text-xs">{{ userMainFunction() }}</p>
	}
</div>

<button
	class="log-out"
	data-test="sign-out-button"
	icon="fa fa-fw fa-sign-out"
	pButton
	[pTooltip]="'auth.signout' | translate"
	(click)="logOut()"
></button>
